
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Building2 } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

interface NavbarActionsProps {
  isCompact?: boolean;
}

export const NavbarActions: React.FC<NavbarActionsProps> = ({ isCompact = false }) => {
  const navigate = useNavigate();
  
  const handlePrivateEvent = () => {
    navigate('/univers-particuliers');
  };
  
  const handleProfessionalEvent = () => {
    navigate('/evenement-entreprise-prestige');
  };
  
  const handleContact = () => {
    navigate('/contact');
  };

  return (
    <div className="flex items-center space-x-4">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="default" 
            size={isCompact ? "sm" : "default"}
            className={`
              group relative overflow-hidden
              bg-primary text-white font-semibold
              shadow-[0_4px_14px_rgba(20,33,61,0.25)]
              hover:shadow-[0_6px_20px_rgba(20,33,61,0.35)]
              hover:scale-[1.02] active:scale-[0.98]
              transition-all duration-200 ease-out
              whitespace-nowrap
              ${isCompact ? 'px-4 py-2 text-sm' : 'px-5 py-2.5'}
            `}
            aria-label="Créer mon évènement"
          >
            {/* Subtle shine effect on hover */}
            <span className="
              absolute inset-0 -translate-x-full 
              bg-gradient-to-r from-transparent via-white/20 to-transparent
              group-hover:translate-x-full transition-transform duration-700
            " />
            
            <span className="relative">Créer mon évènement</span>
          </Button>
        </DropdownMenuTrigger>
        
        <DropdownMenuContent 
          align="end" 
          className="
            w-64 p-2 mt-2
            bg-white border border-border/50 
            shadow-[0_8px_30px_rgba(0,0,0,0.12)] 
            rounded-xl
          "
        >
          <DropdownMenuItem 
            onClick={handlePrivateEvent} 
            className="
              cursor-pointer rounded-lg py-3.5 px-4
              hover:bg-gradient-to-r hover:from-primary/5 hover:to-transparent
              transition-all duration-150
              group
            "
          >
            <div className="flex items-center gap-3">
              <div className="
                p-2 rounded-lg bg-primary/10 
                group-hover:bg-primary/20 transition-colors
              ">
                <Users className="h-4 w-4 text-primary" />
              </div>
              <div className="flex flex-col">
                <span className="font-semibold text-foreground">Évènement privé</span>
                <span className="text-xs text-muted-foreground">Anniversaires, mariages...</span>
              </div>
            </div>
          </DropdownMenuItem>
          
          <DropdownMenuItem 
            onClick={handleProfessionalEvent} 
            className="
              cursor-pointer rounded-lg py-3.5 px-4
              hover:bg-gradient-to-r hover:from-primary/5 hover:to-transparent
              transition-all duration-150
              group
            "
          >
            <div className="flex items-center gap-3">
              <div className="
                p-2 rounded-lg bg-secondary/20 
                group-hover:bg-secondary/30 transition-colors
              ">
                <Building2 className="h-4 w-4 text-secondary-foreground" />
              </div>
              <div className="flex flex-col">
                <span className="font-semibold text-foreground">Évènement professionnel</span>
                <span className="text-xs text-muted-foreground">Séminaires, team building...</span>
              </div>
            </div>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      
    </div>
  );
};
